export default __webpack_public_path__ + "static/slider-2-b7998b89954b44d12e8ea604c837cb56.webp";